import * as React from "react";
import { Button } from "@jhool-io/fe-components";
import ChevronUpIcon from "../../icons/ChevronUp";

export default function ScrollToTopButton() {
    const [show, setShow] = React.useState(false);

    const mainWrapper = document.querySelector("#main");
    const handleScrollToTop = () => {
        mainWrapper?.scrollIntoView({ behavior: "smooth" });
    };

    React.useEffect(() => {
        const handleShowButton = () => {
            if (window.scrollY > 600) {
                setShow(true);
            } else {
                setShow(false);
            }
        };

        window.addEventListener("scroll", handleShowButton);

        return () => window.removeEventListener("scroll", handleShowButton);
    }, []);

    if (show) {
        return (
            <Button
                className="fixed right-2 bottom-10 size-10 rounded-full p-0 z-[5]"
                variant="primary"
                size="auto"
                onClick={handleScrollToTop}
            >
                <ChevronUpIcon className="size-5 stroke-white" />
            </Button>
        );
    }

    return null;
}
